import { PageHeading } from '@/components/shared/PageHeading/PageHeading.tsx';

import cn from './styles.module.sass';

export const TermsOfService = () => {
    return (
        <div className={cn.container}>
            <PageHeading pageName="Пользовательское соглашение" backToPrevLocation />
            <div className={cn.content}>
                <section>
                    <p>
                        Настоящее Пользовательское Соглашение (Далее Соглашение) регулирует
                        отношения между ООО &#34;Агентство связи&#34; (далее Другомания или Администрация)
                        с одной стороны и пользователем сайта с другой.
                        <br />
                        Сайт Другомания не является средством массовой информации.
                    </p>
                    <p>
                        Используя сайт, Вы соглашаетесь с условиями данного соглашения.
                        <br />
                        <strong>
                            Если Вы не согласны с условиями данного соглашения, не используйте сайт
                            friend-mania.ru
                        </strong>
                    </p>
                </section>
                <section>
                    <h2>Права и обязанности сторон</h2>
                    <ul>
                        <h3>Пользователь имеет право:</h3>
                        <li>- осуществлять поиск информации на сайте</li>
                        <li>- получать информацию на сайте</li>
                        <li>- копировать информацию на другие сайты с указанием источника</li>
                        <li>
                            - использовать информацию сайта в коммерческих целях без специального
                            разрешения
                        </li>
                    </ul>
                    <ul>
                        <h3>Администрация имеет право:</h3>
                        <li>
                            - по своему усмотрению и необходимости создавать, изменять, отменять
                            правила
                        </li>
                        <li>- ограничивать доступ к любой информации на сайте</li>
                        <li>- создавать, изменять, удалять информацию</li>
                    </ul>
                    <ul>
                        <h3>Пользователь обязуется:</h3>
                        <li>
                            - обновлять Персональные данные, предоставленные при регистрации, в
                            случае их изменения
                        </li>
                        <li>- не нарушать работоспособность сайта</li>
                        <li>
                            - не создавать несколько учётных записей на Сайте, если фактически они
                            принадлежат одному и тому же лицу
                        </li>
                        <li>
                            - не регистрировать учетную запись от имени или вместо другого лица за
                            исключением случаев, предусмотренных законодательством РФ
                        </li>
                        <li>
                            - не использовать скрипты (программы) для автоматизированного сбора
                            информации и/или взаимодействия с Сайтом и его Сервисами
                        </li>
                    </ul>
                    <ul>
                        <h3>Администрация обязуется:</h3>
                        <li>
                            - поддерживать работоспособность сайта за исключением случаев, когда это
                            невозможно по независящим от Администрации причинам.
                        </li>
                        <li>
                            - защищать информацию, распространение которой ограничено или запрещено
                            законами путем вынесения предупреждения либо удалением учетной записи
                            пользователя, нарушившего правила
                        </li>
                        <li>
                            - предоставить всю доступную информацию о Пользователе уполномоченным на
                            то органам государственной власти в случаях, установленных законом
                        </li>
                    </ul>
                </section>
                <section>
                    <h2>Ответственность сторон</h2>
                    <ul>
                        <h3>Ответственность за достоверность данных абонентов:</h3>
                        <li> 1. Пользователь обязуется вносить в систему только достоверные персональные данные абонентов,
                            полученные от самих абонентов с их прямого согласия.
                        </li>
                        <li>
                            2. Пользователь несёт полную ответственность за законность обработки персональных данных,
                            переданных через его интерфейс.
                        </li>
                        <li>
                            3. Пользователь обязуется подтверждать, что каждый абонент, чьи данные передаются, был уведомлён
                            об их использовании и дал согласие на обработку в соответствии с требованиями Федерального закона №152-ФЗ.
                        </li>
                        <li>
                            4. В случае выявления факта внесения ложных или несанкционированных данных, Компания вправе
                            приостановить доступ Партнёра к системе, аннулировать переданные номера и передать информацию в уполномоченные органы.
                        </li>
                        <li>
                            5. Ущерб, причинённый в результате неправомерных действий Партнёра, подлежит возмещению в полном объёме.
                        </li>
                    </ul>
                    <ul>
                        <h3>Ответственность администрации:</h3>
                        <li>- администрация не несёт ответственность за несовпадение ожидаемых Пользователем и реально полученных услуг</li>
                        <li>- администрация не несет никакой ответственности за услуги, предоставляемые третьими лицами</li>
                        <li>- в случае возникновения форс-мажорной ситуации (боевые действия, чрезвычайное положение, стихийное бедствие и т. д.)
                            Администрация не гарантирует сохранность информации, размещённой Пользователем, а также бесперебойную работу информационного ресурса
                        </li>
                    </ul>
                </section>
                <section>
                    <h2>Условия действия Соглашения</h2>
                    <p>
                        Данное Соглашение вступает в силу при регистрации на сайте.
                        <br />
                        Соглашение перестает действовать при появлении его новой версии.
                        <br />
                        Администрация оставляет за собой право в одностороннем порядке изменять
                        данное соглашение по своему усмотрению.
                        <br />
                        Администрация не оповещает пользователей об изменении в Соглашении.
                    </p>
                </section>
            </div>
        </div>
    );
};
